export default "__VITE_ASSET__107ac951__"